import React from 'react';
import NosPartenaires from '../components/NosPartenaires';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <NosPartenaires />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
